import { getCurrentInstance, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/common/logo.png';
import _imports_1 from '../../assets/common/ic-language.jpg';

const _withScopeId = n => (_pushScopeId("data-v-375afea6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "app-head_box"
};
const _hoisted_2 = {
  class: "app-head_body"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "logo-wrap",
  src: _imports_0
})], -1));

const _hoisted_4 = {
  class: "head-body_middle"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "slider"
};
const _hoisted_7 = {
  class: "head-body_right"
};
const _hoisted_8 = {
  class: "el-dropdown-link"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "12px",
    "height": "12px",
    "margin-right": "5px"
  },
  src: _imports_1
}, null, -1));

import tools from '@/utils/tools';
import { ElMessage } from 'element-plus'; // import { useUserStore } from '@/store/userStore'

import { storeToRefs } from 'pinia';
import { configData } from '@/store/config';
import { computed } from 'vue';
export default {
  __name: 'LayoutHead',

  setup(__props) {
    const config = configData();
    const languageList = [{
      label: 'English',
      value: 'en'
    }, {
      label: '中文',
      value: 'cn'
    }];
    const {
      proxy
    } = getCurrentInstance(); // const store = useUserStore()

    const route = useRoute();
    const router = useRouter();
    const languageOptions = ref({
      label: 'English',
      value: 'en'
    }); // const { userInfo } = storeToRefs(store)

    const menuList = computed(() => {
      return [{
        name: config.languageInfo?.Tracking,
        url: '/tracking'
      }, {
        name: config.languageInfo?.Services,
        url: '/service'
      }, {
        name: config.languageInfo?.News,
        url: '/news'
      }, {
        name: config.languageInfo?.Support,
        url: '/support'
      }, {
        name: config?.languageInfo?.About,
        url: '/about'
      }, {
        name: config?.languageInfo?.Contact,
        url: '/contact'
      }];
    });
    const routeCurrent = computed(() => {
      return route.fullPath;
    });

    function changeMenu(item) {
      if (item.url === routeCurrent.value) return false;
      router.push(item.url);
    }

    function onLanguageClick(e) {
      languageOptions.value = e;
      config.initConfig(languageOptions.value?.value);
    }

    return (_ctx, _cache) => {
      const _component_arrow_down = _resolveComponent("arrow-down");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.url,
          class: _normalizeClass(['nav-item', _unref(routeCurrent) === item.url ? 'active' : ''])
        }, [_createElementVNode("div", {
          onClick: $event => changeMenu(item)
        }, _toDisplayString(item.name), 9, _hoisted_5), _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [[_vShow, _unref(routeCurrent) === item.url]])], 2);
      }), 128))]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "dropStyle"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(languageList, (item, index) => {
            return _createVNode(_component_el_dropdown_item, {
              key: index,
              onClick: $event => onLanguageClick(item)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 64))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createTextVNode(" " + _toDisplayString(languageOptions.value.label) + " ", 1), _createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_arrow_down)]),
          _: 1
        })])]),
        _: 1
      })])])]);
    };
  }

};